// 阿里矢量图标库配置
let iconfontVersion = ['567566_pwc3oottzol'];
let iconfontUrl = `//at.alicdn.com/t/font_$key.css`;

let baseUrl = '';
let codeUrl = `${baseUrl}/code`
const env = process.env

env.VISITION = '23.12.1';
// env.BASEURL = "http://api-hisuat.ygjkq.com";

 
let mode = env.NODE_ENV;
 //  let mode = env.NODE_ENV.npm_config_envmode;   


 switch (mode) {
    case 'development':
        // baseUrl = 'http://hisdev.ygjkq.com:18000';
        baseUrl = '';
        break;
    case 'production':
        // axios.defaults.baseURL = ''
        //uat baseUrl = 'https://api-hisuat.ygjkq.com';
        //baseUrl = 'https://api-his.ygjkq.com';
        baseUrl = 'https://api-his.ygjkq.com';
        // baseUrl = 'http://hisdev.ygjkq.com:18000';
        break;   
    case 'test':
        baseUrl = ''
    break;  
    case 'uat':
        baseUrl = 'https://api-hisuat.ygjkq.com';
    break;  
    case 'prod':
        baseUrl = 'https://api-his.ygjkq.com';
    break;  
    case 'locdev':
        baseUrl = 'http://api-hisdev.ygjkq.com:18000';
    break;  
    default:
        baseUrl = ''
        break;
 }

export {
    baseUrl,
    iconfontUrl,
    iconfontVersion,
    codeUrl,
    env
}
